import "./paymentInfo.scss";

const PaymentInfo = ({ payment }) => {
    return (
        <div className="payment-info">
            {/* 주문번호 */}
            {payment.order_number && (
                <div className="payment-section">
                    <div className="payment-row">
                        <span className="label">주문번호</span>
                        <span className="value">{payment.order_number}</span>
                    </div>
                </div>
            )}

            {/* 주문금액 */}
            <div className="payment-section">
                <div className="payment-row">
                    <span className="label">상품금액</span>
                    <span className="value">
                        {payment.product_price.toLocaleString()}원
                    </span>
                </div>
                <div className="payment-row">
                    <span className="label">배송비</span>
                    <span className="value">
                        {payment.shipping > 0 ? `${payment.shipping.toLocaleString()}원` : "무료"}
                    </span>
                </div>
            </div>

            {/* 총 결제금액 */}
            <div className="payment-section">
                <div className="payment-row total">
                    <span className="label">총 결제금액</span>
                    <span className="value highlight">
                        {payment.total_amount.toLocaleString()}원
                    </span>
                </div>
            </div>
        </div>
    );
};

export default PaymentInfo;
